module.exports = __webpack_public_path__ + "img/tools_HRmarkets.26b444f4.png";